import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Sentry — only initializes when DSN is present (so local dev stays quiet).
// Error-only capture; no performance tracing to preserve the free 5k events/mo
// quota for actual exceptions.
if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        integrations: [],
        tracesSampleRate: 0.0,
        // Drop noise from the GIS popup blocking that fires inside iframes,
        // and from React 19's strict-mode warnings replayed during HMR.
        ignoreErrors: [
            /GSI_LOGGER/,
            /ResizeObserver loop limit exceeded/,
        ],
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
